import {TaskStatus} from '@/pages/ENT/Tasks/taskConfig';
import type {InlineTaskTab} from '@/pages/ENT/SafetyCenter/Inspections/Workspace/inlineTaskTabs';
import {BaseEvent, SimpleEvent} from '../useLogEvent';

export const MANAGER_REPORT_EXTRACTION_CATEGORY = 'MANAGER_REPORT_EXTRACTION';

export type InspectionActionsArm = 'inline' | 'peek';

type TasksListPageEvents =
  | BaseEvent<
      'Tasks List Page - Status Filter Changed',
      {statuses: TaskStatus[]}
    >
  | BaseEvent<'Tasks List Page - Searched', {searchTerm: string}>
  | BaseEvent<'Tasks List Page - List Item Pressed', {id: string}>
  | BaseEvent<'Tasks List Page - Tag Filter Changed', {tagIds: string[]}>
  | SimpleEvent<'Tasks Page - Create Task Button Clicked'>;

type TaskTemplatesPageEvents =
  | BaseEvent<'Task Templates Page - Searched', {searchTerm: string}>
  | BaseEvent<
      'Task Templates Page - Status Filter Changed',
      {statuses: string[]}
    >
  | BaseEvent<'Task Templates Page - Template Opened', {id: string}>;

type InspectionConsolidationEvents =
  | BaseEvent<
      'Inspection Report Extraction - Notification Delivered',
      {notificationId: string}
    >
  | BaseEvent<
      'Inspection Detail - Tabbed View Opened',
      {taskId: string; initialTab: string}
    >
  | BaseEvent<
      'Inspection Actions - Follow Up Task Opened',
      {taskId: string; actionId: string; arm: InspectionActionsArm}
    >
  | BaseEvent<
      'Inspection Actions - Follow Up Task Updated',
      {taskId: string; actionId: string; arm: InspectionActionsArm}
    >
  | BaseEvent<
      'Inspection Actions - Inline Task Tab Opened',
      {
        taskId: string;
        actionId: string;
        followUpTaskId: string;
        tab: InlineTaskTab;
        hasChecklist: boolean;
        stepCount: number;
        arm: InspectionActionsArm;
      }
    >;

export type TasksEvents =
  | TasksListPageEvents
  | TaskTemplatesPageEvents
  | InspectionConsolidationEvents;
